import { Main } from './Main/Main'
import Sidebar from './Sidebar/Sidebar'
import { ThemeProvider } from '@mui/material/styles'
import { theme } from './theme'
import { Footer } from './Footer/Footer'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { accessTokenName, resetLogin, setAccesTokenToAxios } from '../API/auth'

export const Components = () => {
	const navigate = useNavigate()

	const [initialized, setInitialized] = useState(false)
	if (!initialized) {
		setInitialized(true)

		if (!localStorage.getItem(accessTokenName)) {
			resetLogin()
			navigate('/login')
		} else setAccesTokenToAxios(localStorage.getItem(accessTokenName))
	}

	return (
		<ThemeProvider theme={theme}>
			<Sidebar />
			<Main />
			<Footer />
		</ThemeProvider>
	)
}
